(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // CartDrawerQuantitySelector - Handles quantity +/- buttons with immediate change dispatch
  // The default QuantitySelector doesn't dispatch change events on button click, only on blur
  // This custom handler ensures cart updates happen immediately
  function initCartDrawerQuantityHandlers() {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;

    // Quantity Handlers
    cartDrawer.addEventListener('click', function(event) {
      const button = event.target.closest('.quantity-selector__button');
      if (!button) return;

      const quantitySelector = button.closest('quantity-selector');
      if (!quantitySelector) return;

      const input = quantitySelector.querySelector('input[data-line-key]');
      if (!input) return;

      // Wait a tick for the QuantitySelector to update the value
      setTimeout(() => {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 10);
    });
  }

  // Handle Recommendations Navigation (Carousel)
  function initCartDrawerRecommendationsNav() {
    const container = document.querySelector('.cart-drawer__recommendations');
    if (!container) return;

    const list = container.querySelector('.cart-drawer__recommendations-list');
    const prevBtn = container.querySelector('.cart-recommendations-nav-btn--prev');
    const nextBtn = container.querySelector('.cart-recommendations-nav-btn--next');

    if (!list || !prevBtn || !nextBtn) return;

    // Scroll amount = card width + gap
    // Mobile: 120px + 12px gap = 132px
    // Desktop: 140px + 12px gap = 152px
    const getScrollAmount = () => window.innerWidth >= 700 ? 152 : 132;

    prevBtn.addEventListener('click', () => {
      list.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      list.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    
    // Optional: Update button states
    const updateButtons = () => {
      // Small tolerance for calculation errors
      prevBtn.disabled = list.scrollLeft <= 2;
      nextBtn.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    };

    list.addEventListener('scroll', () => {
      // Debounce slightly or just run
      requestAnimationFrame(updateButtons);
    });
    
    // Initial check
    // Wait for content to potentially load (for dynamic recommendations)
    const observer = new MutationObserver(updateButtons);
    observer.observe(list, { childList: true, subtree: true });
    
    // Check immediately
    updateButtons();
    
    // Re-check after a moment (images loading etc)
    setTimeout(updateButtons, 500);
  }

  // Initialize on DOMContentLoaded and section load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCartDrawerQuantityHandlers();
      initCartDrawerRecommendationsNav();
    });
  } else {
    initCartDrawerQuantityHandlers();
    initCartDrawerRecommendationsNav();
  }

  // Handle section events for Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === 'cart-drawer') {
      initCartDrawerQuantityHandlers();
      initCartDrawerRecommendationsNav();
    }
  });

  // Re-initialize carousel when cart updates (since DOM is replaced)
  document.addEventListener('cart:change', function(event) {
    if (event.detail.cart.sections['cart-drawer']) {
       // Wait for DOM update
       setTimeout(() => {
         initCartDrawerRecommendationsNav();
       }, 50);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const SECTION_SELECTOR = '.shopify-section--main-cart';

  const updateCart = async (lineKey, quantity) => {
    const wrapper = document.querySelector(SECTION_SELECTOR);
    if (!wrapper) return;

    const sectionId = wrapper.id.replace('shopify-section-', '');

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity, sections: [sectionId] })
      });

      if (!response.ok) throw new Error();
      const data = await response.json();

      if (data.sections?.[sectionId]) {
        wrapper.outerHTML = data.sections[sectionId];
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: data }
      }));
    } catch {
      window.location.href = `${window.Shopify.routes.root}cart/change?id=${lineKey}&quantity=${quantity}`;
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.hasAttribute?.('data-line-key')) return;
    if (!event.target.closest(SECTION_SELECTOR)) return;

    event.stopPropagation();
    const lineKey = event.target.getAttribute('data-line-key');
    const quantity = parseInt(event.target.value);
    if (isNaN(quantity) || quantity < 0) {
      event.target.value = 1;
      return;
    }
    updateCart(lineKey, quantity);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href*="/cart/change"]');
    if (!link || !link.closest(SECTION_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    const url = new URL(link.href);
    updateCart(url.searchParams.get('id'), parseInt(url.searchParams.get('quantity')) || 0);
  }, true);
})();

  } catch(e) { console.error(e); }
})();
})();
